module.exports = __webpack_public_path__ + "static/media/ei_step.7dba01bb.png";